import React, { useEffect } from 'react';
import { Form, Row, Col, Container } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form/dist/react-hook-form.ie11';
import { CheckboxInput } from '../../Helpers/Inputs';
import { createTheme, ThemeProvider } from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";
import FormGroup from '@material-ui/core/FormGroup';
import HazardousActivitiesIcon from '../../../icons/hazardousActivities.svg';
import Button from '@material-ui/core/Button';
import SvgIcon from '@material-ui/core/SvgIcon';

import "./Adventures.scss";

const useStyles = makeStyles(theme => ({
  lightBackground: {
    backgroundColor: `${theme.palette.primary.main}16`,
  },
}));

const adventuresTheme = {
  overrides: {
    MuiFormControl: {
      root: {
        marginBottom: 4,
      },
    },
    MuiFormControlLabel: {
      root: {
        alignItems: "flex-start",
        marginTop: 0,
        marginRight: 0,
        marginBottom: 0,
        marginLeft: -2,
        paddingRight: 10,
      },
      label: {
        paddingTop: 4,
      },
    },
    MuiCheckbox: {
      root: {
        color: "#c6c6c6",
        marginRight: 8,
        padding: 0,
      },
    },
  },
};

export default function Adventures(props) {

  const classes = useStyles();

  const { register, errors, handleSubmit, setValue, triggerValidation, reset } = useForm({
    mode: 'onBlur',
    reValidateMode: 'onBlur',
  });

  const noneOfTheAboveDisabled =
    props.formState.automobileOrMotorcycleRacing ||
    props.formState.ballooning ||
    props.formState.bungeeJumping ||
    props.formState.hangGliding ||
    props.formState.pilotingAnAircraft ||
    props.formState.scubaDiving ||
    props.formState.skyDiving;

  const handleValueChange = (field, value) => {
    setValue(field, value);
    props.onFieldChange(field, value);
    triggerValidation(field);    
  };

  useEffect(() => {
    register({ name: 'automobileOrMotorcycleRacing' });
    setValue('automobileOrMotorcycleRacing', props.formState.automobileOrMotorcycleRacing);

    register({ name: 'ballooning' });
    setValue('ballooning', props.formState.ballooning);

    register({ name: 'bungeeJumping' });
    setValue('bungeeJumping', props.formState.bungeeJumping);

    register({ name: 'hangGliding' });
    setValue('hangGliding', props.formState.hangGliding);

    register({ name: 'pilotingAnAircraft' });
    setValue('pilotingAnAircraft', props.formState.pilotingAnAircraft);

    register({ name: 'scubaDiving' });
    setValue('scubaDiving', props.formState.scubaDiving);

    register({ name: 'skyDiving' });
    setValue('skyDiving', props.formState.skyDiving);

    register({ name: 'none' });
    setValue('none', props.formState.none);
  }, [register]);

  useEffect(() => {
    if (noneOfTheAboveDisabled && props.formState.none) {
      props.onFieldChange('none', false);
    } else if (!noneOfTheAboveDisabled && !props.formState.none) {
      props.onFieldChange('none', true);
    }
  }, [noneOfTheAboveDisabled]);


  return (
    <ThemeProvider theme={(theme) => createTheme({
      ...theme,
      ...adventuresTheme,
    })}>
    <Container className="adventure-form personalize-step">
      <Form onSubmit={handleSubmit(props.onNext)}>
        <Row className="justify-content-center">
          <Col lg={4} className="adventures-container">
            <Row className="justify-content-center pt-2">
              <div className={`icon-container ${classes.lightBackground}`}>
                <SvgIcon component={HazardousActivitiesIcon} color="primary" fontSize="large"/>
              </div>
            </Row>
            <Row className="justify-content-center">
              <p className="mainTitle">Adventures</p>
            </Row>
            <Row className="row-content">
              <p className="subTitle">I have participated in the following:</p>
            </Row>
            <Row className="row-content">
              <FormGroup className="checkboxes">
                <CheckboxInput
                  name="automobileOrMotorcycleRacing"
                  id="automobileOrMotorcycleRacing"
                  checked={props.formState.automobileOrMotorcycleRacing}
                  onChange={(e) => handleValueChange('automobileOrMotorcycleRacing', e.target.checked)}
                  errors={errors && errors.automobileOrMotorcycleRacing}
                  inputRef={register}
                  label="Automobile or Motorcycle Racing"
                />
                <CheckboxInput
                  name="ballooning"
                  id="ballooning"
                  checked={props.formState.ballooning}
                  onChange={(e) => handleValueChange('ballooning', e.target.checked)}
                  errors={errors && errors.ballooning}
                  inputRef={register}
                  label="Ballooning"
                />
                <CheckboxInput
                  name="bungeeJumping"
                  id="bungeeJumping"
                  checked={props.formState.bungeeJumping}
                  onChange={(e) => handleValueChange('bungeeJumping', e.target.checked)}
                  errors={errors && errors.bungeeJumping}
                  inputRef={register}
                  label="Bungee Jumping"
                />
                <CheckboxInput
                  name="hangGliding"
                  id="hangGliding"
                  checked={props.formState.hangGliding}
                  onChange={(e) => handleValueChange('hangGliding', e.target.checked)}
                  errors={errors && errors.hangGliding}
                  inputRef={register}
                  label="Hang Gliding"
                />
                <CheckboxInput
                  name="pilotingAnAircraft"
                  id="pilotingAnAircraft"
                  checked={props.formState.pilotingAnAircraft}
                  onChange={(e) => handleValueChange('pilotingAnAircraft', e.target.checked)}
                  errors={errors && errors.pilotingAnAircraft}
                  inputRef={register}
                  label="Piloting an aircraft"
                />
                <CheckboxInput
                  name="scubaDiving"
                  id="scubaDiving"
                  checked={props.formState.scubaDiving}
                  onChange={(e) => handleValueChange('scubaDiving', e.target.checked)}
                  errors={errors && errors.scubaDiving}
                  inputRef={register}
                  label="Scuba Diving"
                />
                <CheckboxInput
                  name="skyDiving"
                  id="skyDiving"
                  checked={props.formState.skyDiving}
                  onChange={(e) => handleValueChange('skyDiving', e.target.checked)}
                  errors={errors && errors.skyDiving}
                  inputRef={register}
                  label="Sky Diving"
                />
                <CheckboxInput
                  name="none"
                  id="none"
                  checked={props.formState.none}
                  errors={errors && errors.none}
                  disabled={noneOfTheAboveDisabled}
                  inputRef={register}
                  label="None of the Above"
                />
              </FormGroup>
            </Row>
          </Col>
        </Row>
        <Row className="pre-quote-nav-control">
          <Col className="text-left btn-back">
            <Button variant="outlined" size="medium" color="primary" className="px-4" onClick={props.onBack}>
              BACK
            </Button>
          </Col>
          <Col className="text-right">
            <Button variant="contained" size="medium" color="primary" type="submit" className="px-4">
              NEXT
            </Button>
          </Col>
        </Row>

      </Form>
    </Container>
    </ThemeProvider>
  );
}

Adventures.propTypes = {
  formState: PropTypes.object.isRequired,
  onNext: PropTypes.func.isRequired,
  onFieldChange: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
};

Adventures.DefaultFormState = () => {
  return {
    automobileOrMotorcycleRacing: false,
    ballooning: false,
    bungeeJumping: false,
    hangGliding: false,
    pilotingAnAircraft: false,
    scubaDiving: false,
    skyDiving: false,
    none: true,
  };
};



// WEBPACK FOOTER //
// ./src/components/Quoters/Common/Adventures.js